import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { createConsumer } from '@rails/actioncable';
import { transformResultPayload } from '../actions/transformers';

const CHANNEL_NAME = 'Dashboard::CoachChatChannel';

export function useMessageChannel(playerId, onNewMessage) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!playerId) return;

    const cable = createConsumer();
    const subscription = cable.subscriptions.create(
      { channel: CHANNEL_NAME, room: playerId },
      {
        received: (data) => {
          const transformedData = transformResultPayload(data);

          if (onNewMessage) {
            onNewMessage(transformedData);
          }

          queryClient.setQueryData(['conversation', playerId], (oldData) => {
            if (!oldData) {
              return oldData;
            }

            return {
              ...oldData,
              messages: [...oldData.messages, transformedData]
            };
          });
        },
        rejected: () => {
          console.error('Connection to chat channel rejected');
        }
      }
    );

    return () => {
      cable.subscriptions.remove(subscription);
    };
  }, [playerId, queryClient, onNewMessage]);
}
